import { render, staticRenderFns } from "./Mailchimp.vue?vue&type=template&id=a81ff520&scoped=true&"
var script = {}
import style0 from "./Mailchimp.vue?vue&type=style&index=0&id=a81ff520&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a81ff520",
  null
  
)

export default component.exports